import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hacker-news-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM21.2 229.2h-0.2c0.1-0.1 0.2-0.3 0.3-0.4 0 0.1 0 0.3-0.1 0.4zM239.2 283.1l80.8-155.1h-34.8c-54.8 101.2-48.3 98.6-60.6 125.6-10.1-24.4-6.8-27.3-59.3-125.6h-37.3l79.8 153.3v102.7h31.4v-100.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hacker-news-square.js
// module id = 874
// module chunks = 0